import { render, staticRenderFns } from "./dot-category.vue?vue&type=template&id=50e07c34&"
import script from "./dot-category.vue?vue&type=script&lang=js&"
export * from "./dot-category.vue?vue&type=script&lang=js&"
import style0 from "./dot-category.vue?vue&type=style&index=0&id=50e07c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports